module.exports = __webpack_public_path__ + "static/media/plus.e50b7210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 120
// module chunks = 0